export const SITE_SEO_KEYS = {
  title: 'site.seo.title',
  description: 'site.seo.description',
  keywords: 'site.seo.keywords',
}

/**
 * SEO 文案优先用 `tm` 取原始字符串，避免 `t()` 将 `|` 解析为复数分隔符而截断 title。
 */
export function resolveSeoText(t, te, tm, key, fallbackKey) {
  const pick = (k) => {
    if (!k || !te(k)) return null
    const raw = tm(k)
    if (typeof raw === 'string') return raw
    return t(k)
  }

  return pick(key) ?? pick(fallbackKey) ?? ''
}
